
import { Component, Prop, Vue } from "vue-property-decorator";
import { UFliterals } from "@/utils/literals";
import { ITip } from "@/schemas/ITip";
import Tip from "@/components/tips/Tip.vue";
import TextCarousel from "@/components/TextCarousel.vue";
import { UnitType } from "@/schemas/Enums";

@Component({
  name: "TipsContainer",
  components: { TextCarousel, Tip },
})
export default class TipsContainer extends Vue {
  @Prop({ required: true, type: Array })
  tips!: ITip[];
  @Prop({ required: true, type: Number })
  sessionTime!: number;
  @Prop({ required: true, type: String })
  startedAt!: number;
  @Prop({ required: true })
  carousel!: {
    carousel_tips: boolean;
    carousel_tip_unit?: UnitType;
    carousel_display_time?: number;
    carousel_occurrence?: number;
  };

  created(): void {
    console.log(this.carousel.carousel_tips);
  }

  getUF(key: string): string {
    return UFliterals[key];
  }

  get carouselTimeout(): number {
    if (this.carousel.carousel_tips) {
      if (this.carousel.carousel_tip_unit === UnitType.Occurrences) {
        return (
          (this.sessionTime /
            (this.carousel.carousel_occurrence * this.tips.length)) *
          60000
        );
      }
      return this.carousel.carousel_display_time * 60000;
    }
    return 2000;
  }

  onHighlightChanged(event: { is_highlight: boolean; tip_id: string }): void {
    this.$emit("highlightChanged", {
      tip_id: event.tip_id,
      is_highlight: event.is_highlight,
    });
  }
}
